module.exports = __webpack_public_path__ + "img/1.95665262.png";